const midday = ['IMG_0001.JPG',
'IMG_0002.JPG',
'IMG_0011.JPG',
'IMG_0074.JPG',
'IMG_0080.JPG',
'IMG_0104.JPG',
'IMG_0116.JPG',
'IMG_0122.JPG',
'IMG_0126.JPG',
'IMG_0127.JPG',
'IMG_0145.JPG',
'IMG_0158.JPG',
'IMG_0159.JPG',
'IMG_0160.JPG',
'IMG_0277.JPG',
'IMG_0278.JPG',
'IMG_0281.JPG',
'IMG_0283.JPG',
'IMG_0292.JPG',
'IMG_0295.JPG',
'IMG_0303.JPG',
'IMG_0306.JPG',
'IMG_0307.JPG',
'IMG_0309.JPG',
'IMG_0310.JPG',
'IMG_0312.JPG',
'IMG_0313.JPG',
'IMG_0318.JPG',
'IMG_0319.JPG',
'IMG_0321.JPG',
'IMG_0322.JPG',
'IMG_0323.JPG',
'IMG_0325.JPG',
'IMG_0333.JPG',
'IMG_0335.JPG',
'IMG_0338.JPG',
'IMG_0339.JPG',
'IMG_0358.JPG',
'IMG_0364.JPG',
'IMG_0366.JPG',
'IMG_0367.JPG',
'IMG_0370.JPG',
'IMG_0371.JPG',
'IMG_0372.JPG',
'IMG_0408.JPG',
'IMG_0409.JPG',
'IMG_0558.JPG',
'IMG_0614.JPG',
'IMG_0714.JPG',
'IMG_0718.JPG',
'IMG_0724.JPG',
'IMG_0824.JPG',
'IMG_0834.JPG',
'IMG_0840.JPG',
'IMG_0841.JPG',
'IMG_0853.JPG',
'IMG_0863.JPG',
'IMG_0867.JPG',
'IMG_0939.JPG',
'IMG_1051.JPG',
'IMG_1086.JPG',
'IMG_1351.JPG',
'IMG_1365.JPG',
'IMG_1467.JPG',
'IMG_1473.JPG',
'IMG_1552.JPG',
'IMG_1577.JPG',
'IMG_1583.JPG',
'IMG_1591.JPG',
'IMG_1592.JPG',
'IMG_1600.JPG',
'IMG_1664.JPG',
'IMG_1665.JPG',
'IMG_1671.JPG',
'IMG_1678.JPG',
'IMG_1681.JPG',
'IMG_1720.JPG',
'IMG_1723.JPG',
'IMG_1779.JPG',
'IMG_1780.JPG',
'IMG_1784.JPG',
'IMG_1823.JPG',
'IMG_1915.JPG',
'IMG_1918.JPG',
'IMG_1926.JPG',
'IMG_1927.JPG',
'IMG_2006.JPG',
'IMG_2092.JPG',
'IMG_2115.JPG',
'IMG_2244.JPG',
'IMG_2268.JPG',
'IMG_2273.JPG',
'IMG_2295.JPG',
'IMG_2296.JPG',
'IMG_2305.JPG',
'IMG_2306.JPG',
'IMG_2312.JPG',
'IMG_2330.JPG',
'IMG_2429.JPG',
'IMG_2437.JPG',
'IMG_2452.JPG',
'IMG_2462.JPG',
'IMG_2467.JPG',
'IMG_2514.JPG',
'IMG_2515.JPG',
'IMG_2585.JPG',
'IMG_2594.JPG',
'IMG_2635.JPG',
'IMG_2654.JPG',
'IMG_2655.JPG',
'IMG_2657.JPG',
'IMG_2658.JPG',
'IMG_2659.JPG',
'IMG_2757.JPG',
'IMG_2861.JPG',
'IMG_2983.JPG',
'IMG_3025.JPG',
'IMG_3031.JPG',
'IMG_3084.JPG',
'IMG_3086.JPG',
'IMG_3105.JPG',
'IMG_3120.JPG',
'IMG_3127.JPG',
'IMG_3128.JPG',
'IMG_3172.JPG',
'IMG_3177.JPG',
'IMG_3216.JPG',
'IMG_3245.JPG',
'IMG_3275.JPG',
'IMG_3289.JPG',
'IMG_3449.JPG',
'IMG_3469.JPG',
'IMG_3470.JPG',
'IMG_3480.JPG',
'IMG_3497.JPG',
'IMG_3557.JPG',
'IMG_3610.JPG',
'IMG_3611.JPG',
'IMG_3612.JPG',
'IMG_3613.JPG',
'IMG_3621.JPG',
'IMG_3629.JPG',
'IMG_3645.JPG',
'IMG_3646.JPG',
'IMG_3694.JPG',
'IMG_3696.JPG',
'IMG_3752.JPG',
'IMG_3836.JPG',
'IMG_3878.JPG',
'IMG_3909.JPG',
'IMG_3952.JPG',
'IMG_4229.JPG',
'IMG_4233.JPG',
'IMG_4251.JPG',
'IMG_4252.JPG',
'IMG_4263.JPG',
'IMG_4272.JPG',
'IMG_4273.JPG',
'IMG_4274.JPG',
'IMG_4276.JPG',
'IMG_4287.JPG',
'IMG_4314.JPG',
'IMG_4315.JPG',
'IMG_4326.JPG',
'IMG_4331.JPG',
'IMG_4394.JPG',
'IMG_4399.JPG',
'IMG_4400.JPG',
'IMG_4461.JPG',
'IMG_4518.JPG',
'IMG_4519.JPG',
'RebelXS_IMG_0408.JPG',
'RebelXS_IMG_0476.JPG',
'RebelXS_IMG_0503.JPG',
'RebelXS_IMG_0510.JPG',
'RebelXS_IMG_0511.JPG',
'RebelXS_IMG_0512.JPG',
'RebelXS_IMG_0519.JPG',
'RebelXS_IMG_0565.JPG',
'RebelXS_IMG_0570.JPG',
'RebelXS_IMG_0576.JPG',
'RebelXS_IMG_0588.JPG',
'RebelXS_IMG_0589.JPG',
'RebelXS_IMG_0593.JPG',
'RebelXS_IMG_0595.JPG',
'RebelXS_IMG_0599.JPG',
'RebelXS_IMG_0601.JPG',
'RebelXS_IMG_0604.JPG',
'RebelXS_IMG_0618.JPG',
'RebelXS_IMG_0622.JPG',
'RebelXS_IMG_0623.JPG',
'RebelXS_IMG_0624.JPG',
'RebelXS_IMG_0635.JPG',
'RebelXS_IMG_0642.JPG',
'RebelXS_IMG_0654.JPG',
'RebelXS_IMG_0655.JPG',
'RebelXS_IMG_0762.JPG',
'RebelXS_IMG_0783.JPG',
'RebelXS_IMG_0786.JPG',
'RebelXS_IMG_0875.JPG',
'RebelXS_IMG_0954.JPG',
'RebelXS_IMG_0967.JPG',
'RebelXS_IMG_0973.JPG',
'RebelXS_IMG_1016.JPG',
'RebelXS_IMG_1649.JPG',
'RebelXS_IMG_1650.JPG',
'RebelXS_IMG_2335.JPG',
'RebelXS_IMG_2420.JPG',
'RebelXS_IMG_2427.JPG',
'RebelXS_IMG_2492.JPG',
'RebelXS_IMG_2496.JPG',
'RebelXS_IMG_2662.JPG',
'RebelXS_IMG_2669.JPG',
'RebelXS_IMG_2671.JPG',
'RebelXS_IMG_2744.JPG',
'RebelXS_IMG_2745.JPG',
'RebelXS_IMG_2746.JPG',
'RebelXS_IMG_2986.JPG',
'RebelXS_IMG_3018.JPG',
'RebelXS_IMG_3019.JPG',
'RebelXS_IMG_3021.JPG',
'RebelXS_IMG_3022.JPG',
'RebelXS_IMG_3024.JPG',
'RebelXS_IMG_3026.JPG',
'RebelXS_IMG_3027.JPG',
'RebelXS_IMG_3029.JPG',
'RebelXS_IMG_3033.JPG',
'RebelXS_IMG_3035.JPG',
'RebelXS_IMG_3114.JPG',
'RebelXS_IMG_3241.JPG',
'RebelXS_IMG_3452.JPG',
'STA_1705.JPG',
'STC_3239.JPG',
'STE_3214.JPG',
'STG_3243.JPG',
'STJ_2323.JPG',
'iPhone2G_IMG_0065.JPG',
'iPhone2G_IMG_0266.JPG',
'iPhone2G_IMG_0500.JPG',
'iPhone2G_IMG_0502.JPG'];

export default midday;